import { forwardRef } from "react";
import Select, { Props as SelectProps } from "react-select";
import Creatable from "react-select/creatable";
import colors from "../../assets/theme/base/colors";
import styles from "./styles";

interface FaiSelectProps extends SelectProps {
	size?: "small" | "medium" | "large";
	error?: boolean;
	success?: boolean;
	isCreatable?: boolean;
	isMulti?: boolean;
}

const FaiSelect = forwardRef<any, FaiSelectProps>(
	(
		{
			size = "medium", // Set default value here
			error = false, // Set default value here
			success = false, // Set default value here
			isCreatable = false,
			...rest
		},
		ref
	) => {
		const { light } = colors;

		const SelectComponent = isCreatable ? Creatable : Select;

		return (
			<SelectComponent
				{...rest}
				ref={ref}
				// @ts-ignore
				styles={styles(size, error, success)}
				theme={(theme) => ({
					...theme,
					colors: {
						...theme.colors,
						primary25: light.main,
						primary: light.main,
					},
				})}
			/>
		);
	}
);

export default FaiSelect;
